import { render } from "./RoomView.vue?vue&type=template&id=3da7505b&ts=true"
import script from "./RoomView.vue?vue&type=script&lang=ts"
export * from "./RoomView.vue?vue&type=script&lang=ts"

import "./RoomView.vue?vue&type=style&index=0&id=3da7505b&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__